module.exports = __webpack_public_path__ + "img/colapse.a1d2435e.svg";